import Axios from "axios";

const http = Axios.create({
	baseURL: "/api",
	timeout: 180000,
	params: { _dc: null }
});

//Request interceptor
http.interceptors.request.use(function (request) {
	if (!request.params) request.params = {};
	request.params._dc = new Date().getTime();
	return request;
});

//Response interceptor
http.interceptors.response.use(function (response) {
	return response;
});

export default http;
